import axiosInstance from "services/AxiosInstance";
import { ResponseType, TUser } from "types";

import { UserInterface } from "../types/UserDto";

export const postUserAdminService = async (payload: UserInterface): Promise<ResponseType<TUser>> => {
  const response = await axiosInstance.post("/users/admin", payload);
  return response.data;
};
